module.exports = __webpack_public_path__ + "static/media/test13_3.eb722061.png";